import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      d: "M20.5 10.937V19a3 3 0 0 1-3 3h-11a3 3 0 0 1-3-3v-8.063M12 6v16m0-16 1.817-2.927a2.262 2.262 0 0 1 3.862 2.356L17.337 6M12 6l-1.817-2.927a2.262 2.262 0 0 0-3.861 2.356L6.665 6M4 11h16a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v1a2 2 0 0 0 2 2"
    }, null, -1)
  ])))
}
export default { render: render }